import {
  Button,
  FlexBox,
  JoonUIColor,
  Modal,
  Typography,
} from "@joonapp/web-shared"
import { create } from "zustand"

import { useCheckoutRedirect } from "../../pages/paywall/useCheckoutRedirect"
interface FreeTrialLimitModalStore {
  isOpen: boolean
  onOpen: (remainingQuests?: number) => void
  onClose: () => void
  remainingQuests: number
}

export const useFreeTrialLimitModal = create<FreeTrialLimitModalStore>(
  (set) => ({
    isOpen: false,
    onOpen: (remainingQuests = 0) => set({ isOpen: true, remainingQuests }),
    onClose: () => set({ isOpen: false }),
    remainingQuests: 0,
  })
)

const FreeTrialLimitModal = () => {
  const { isOpen, onClose, remainingQuests } = useFreeTrialLimitModal()
  const { redirectToFamilyCheckout, isLoadingCheckoutFn } =
    useCheckoutRedirect()

  const handleRedirect = async () => {
    await redirectToFamilyCheckout()
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} displayCloseIcon animate>
      <FlexBox direction="column" style={{ width: "min(450px, 95vw)" }}>
        <img
          src="/images/free_limit_reached.png"
          alt="Free limit reached"
          style={{ width: "100%" }}
        />
        <div className="w-full flex flex-col gap-4 p-6 text-center">
          <Typography variant="h2" textAlign="center">
            Unlock Unlimited Access
          </Typography>
          {remainingQuests > 0 ? (
            <Typography variant="body">
              You don't have enough verifies left for today. Come back tomorrow
              or start a free trial to verify more Quests.
            </Typography>
          ) : (
            <Typography variant="body" textAlign="center" className="px-4">
              To verify more Quests, come back tomorrow or
              <Typography variant="bodyBold"> start a free trial.</Typography>
            </Typography>
          )}
          <Button
            text={
              <Typography variant="h3" color={JoonUIColor.text.inverted}>
                Start Free Trial
              </Typography>
            }
            isLoading={isLoadingCheckoutFn}
            onClick={handleRedirect}
            fullWidth
          />
        </div>
      </FlexBox>
    </Modal>
  )
}

export default FreeTrialLimitModal
